import { Modal, Button } from "react-bootstrap";

const Heading = ({ children }) => (
  <h5 style={{ color: "rgb(46, 46, 46)", marginBottom: "10px" }}>{children}</h5>
);

const Paragraph = ({ children }) => (
  <p style={{ color: "rgb(66, 66, 66)", marginBottom: "10px" }}>{children}</p>
);

function WithdrawTermsModal({ show, onClose }) {
  const handleYes = () => onClose(true);
  const handleNo = () => onClose(false);

  return (
    <Modal show={show} onHide={() => onClose(false)}>
      <Modal.Header closeButton style={{ backgroundColor: "white" }}>
        <Modal.Title style={{ color: "black" }}>
          Withdraw Terms and Conditions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Heading>1. Interac e-Transfer Only</Heading>
        <Paragraph>
          1.1. Withdrawals are processed exclusively by{" "}
          <b>Interac e-Transfer</b>.
        </Paragraph>

        <Heading>2. Autodeposit Requirement</Heading>
        <Paragraph>
          2.1. Transfers can only be completed if the email address associated
          with your account has <b>Autodeposit</b> enabled under the registered
          full name that appears in your account name.
        </Paragraph>
        <Paragraph>
          2.2. It is your responsibility to ensure that your Interac Autodeposit
          registration matches the email and full name on your account. We shall
          not be held liable if the funds cannot be delivered due to a mismatch.
        </Paragraph>

        <Heading>3. Processing Time</Heading>
        <Paragraph>
          3.1. Transfers will be processed as soon as possible,{" "}
          <b>without guarantees</b> as to the exact timing of delivery.
        </Paragraph>

        <Heading>4. Ineligible Amounts</Heading>
        <Paragraph>
          4.1. Any amounts resulting from a{" "}
          <b>bug, glitch, exploit, hack, error, or malfunction</b> of the
          platform will not be paid out and may be reversed at our sole
          discretion.
        </Paragraph>
        <Paragraph>
          4.2. We reserve the right to void any transaction, balance, or
          winnings that arise from such circumstances and to take appropriate
          action on the account involved.
        </Paragraph>

        <Heading>5. Acknowledgment of Terms</Heading>
        <Paragraph>
          5.1. By proceeding with a withdrawal, you agree to the above terms and
          conditions in full.
        </Paragraph>
        <Paragraph>5.2. Thank you for choosing our service.</Paragraph>

        {/*
                <Heading>1. Currency Selection and Payment Method</Heading>
                <Paragraph>1.1. You shall select the currency for deposit and specify the desired payment method.</Paragraph>
                <Paragraph>1.2. It is your responsibility to ensure the accuracy of the recipient address. We shall not be held liable if the funds are not received due to errors or inaccuracies in the provided information.</Paragraph>

                <Heading>2. Accepted Payment Methods</Heading>
                <Paragraph>2.1. We accept the following payment methods:</Paragraph>
                <Paragraph>2.1.1. <b>Interac e-transfer</b>: You must ensure that the recipient email and message details are correct and complete.</Paragraph>
                <Paragraph>2.1.2. <b>BTC</b>: Transactions must be made exclusively on the BTC chain.</Paragraph>
                <Paragraph>2.1.3. <b>ETH and USDT</b>: Transactions must be carried out solely on the ERC20 chain.</Paragraph>
                <Paragraph>2.1.4. <b>LTC</b>: Transactions must occur exclusively on the LTC chain.</Paragraph>
                <Paragraph>2.2. The correct deposit address will be displayed to you after clicking on the <b>Deposit</b> button.</Paragraph>

                <Heading>3. Transaction Timing</Heading>
                <Paragraph>3.1. You acknowledge that, depending on the selected payment method, the funds must be transmitted within <b>XX minutes</b> from the initiation of the transaction.</Paragraph>
                <Paragraph>3.2. Failure to complete the transfer within the given timeframe will result in the transaction being marked as <b>failed</b>.</Paragraph>

                <Heading>4. Conversion and Service Fees</Heading>
                <Paragraph>4.1. Upon receipt of the funds, applicable conversion and service fees will be calculated and deducted.</Paragraph>
                <Paragraph>4.2. The actual fees may vary slightly from the estimated fees presented prior to the transaction. You agree to these potential discrepancies.</Paragraph>

                <Heading>5. Receipt of Full Amount</Heading>
                <Paragraph>5.1. You must ensure that the exact agreed deposit amount is sent to the provided address.</Paragraph>
                <Paragraph>5.2. For cryptocurrency deposits, you shall bear the responsibility of covering all blockchain fees to ensure that the full agreed amount is received.</Paragraph>

                <Heading>6. Rejected Transactions</Heading>
                <Paragraph>6.1. If the amount received does not match the agreed deposit amount, we reserve the right to reject the transaction.</Paragraph>
                <Paragraph>6.2. Any rejection may result in delays and additional fees.</Paragraph>
                <Paragraph>6.3. You will be required to open a support ticket and provide further information to resolve the discrepancy.</Paragraph>

                <Heading>7. Failed Transactions</Heading>
                <Paragraph>7.1. If the transaction is not completed as agreed, we will designate the transaction as <b>failed</b> after a reasonable period has elapsed without the funds being received.</Paragraph>

                <Heading>8. Transaction Limitations</Heading>
                <Paragraph>8.1. To prevent system abuse, you are limited to a maximum of <b>3 "in-progress" transactions</b> at any given time.</Paragraph>
                <Paragraph>8.2. Repeated failed attempts may result in temporary restrictions on further transactions.</Paragraph>

                <Heading>9. Acknowledgment of Terms</Heading>
                <Paragraph>9.1. By proceeding with a deposit, you agree to the above terms and conditions in full.</Paragraph>
                <Paragraph>9.2. Thank you for choosing our service.</Paragraph>
                */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleNo}>
          Close
        </Button>
        <Button variant="success" onClick={handleYes}>
          I Agree
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default WithdrawTermsModal;
